import { FilterSelect, SearchField } from "@/modules/common/components";
import { EventParticipantStatus, participantStatusOptions } from "../../../../constants";
import { OptionType } from '@/modules/common/types';

import { ChangeTypes, EventFiltersType, FiltersChangeType } from "@/modules/eventsV2/hooks";

interface TableFiltersProps {
  types: OptionType[];
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}

export function ParticipantsTableFilters({
  types,
  filters,
  onFilters,
}: TableFiltersProps) {
  return (
    <div className="flex gap-4">
      <SearchField
        placeholder="Search by name or email"
        defaultValue={filters.search || ''}
        className="w-full max-w-[250px]"
        onChange={(value) => onFilters({ search: value }, ChangeTypes.Debounce)}
      />

      <div className="flex-1">
        <FilterSelect
          options={types}
          label="Type"
          value={filters.type}
          onChange={(value) => onFilters({ type: value })}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={participantStatusOptions}
          label="Status"
          value={filters.status}
          onChange={(value: EventParticipantStatus) => onFilters({ status: value })}
        />
      </div>
    </div>
  );
}
